<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="站点编号" prop="code">
        <el-input v-model="form.code" :disabled="form.id" placeholder="请输入站点编号，全局唯一" v-trim/>
      </el-form-item>
      <el-form-item label="站点名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入站点名称" v-trim/>
      </el-form-item>
      <!-- <el-form-item label="站点ip" prop="ip">
        <el-input v-model="form.ip" placeholder="请输入站点ip地址" v-trim/>
      </el-form-item>
      <el-form-item label="站点端口号" prop="port">
        <el-input v-model="form.port" placeholder="请输入站点端口号" v-trim/>
      </el-form-item> -->

      <!-- <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item> -->
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaSitesWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        code: '',
        ip: '',
        port: ''

        // createDate: '',
        // creator: '',
        // editDate: '',
        // editor: '',
        // isdeleted: '',
        // info: '',
        // name: '',
        // code: '',
        // status: '',
        // lockNum: '',

      },
      // 验证规则
      rules: {
        code: [
          { required: true, message: '请输入站点编号', tigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入站点名称', tigger: 'blur' },
        ],
        ip: [
          { required: true, message: '请输入站点ip地址', tigger: 'blur' },
        ],
        port: [
          { required: true, message: '请输入站点端口号', tigger: 'blur' },
        ],
      }
    }
  },
  created () {
    this.config({
      api: '/business/sites',
      'field.id': 'id'
    })
  }
}
</script>
